/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../../core/utils"
import moment from "moment"
import * as yup from "yup"

// error messages
const requiredMessage = () => loc`Required`
const userMustAssertToBeCardOwnerMessage = () =>
  loc`Please assert you're the real card owner`
const monthMustBeBeetweenOneAndTwelve = () => loc`Not a valid MM value`
const yearFormatMessage = () => loc`Not a valid YYYY date`
const cardIsExpired = () => loc`Your credit card is expired`
const mustBeComposedOfThreeDigitsMessage = () =>
  loc`Must be composed of 3 digits`
const twelveToNineteenDigitsMessage = () =>
  loc`Must be composed of 12-19 digits`
const threeDigitsPattern = "^[0-9]{3,3}$"
const twelveToNineteenDigitsPattern = "^[0-9]{12,19}$"
const yyyyDateFormatPattern = "^[0-9]{4}$"

// todo : refactor in helpers redundant test

const schema = yup.object().shape({
  userIsRealCardOwner: yup
    .boolean()
    .required(requiredMessage)
    .oneOf([true], userMustAssertToBeCardOwnerMessage),
  month: yup
    .string()
    .required(requiredMessage)
    .oneOf(
      ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      monthMustBeBeetweenOneAndTwelve
    )
    .test({
      name: "cbMonthVerification",
      message: "",
      test(value) {
        const cardExpirationDate = moment(
          value + "/" + this.options.parent?.year,
          "MM/YYYY",
          true
        )
        const currentDate = moment()

        if (
          cardExpirationDate.isValid() &&
          (cardExpirationDate.year() !== currentDate.year() ||
            cardExpirationDate.month() !== currentDate.month()) &&
          currentDate.isAfter(cardExpirationDate)
        ) {
          return this.createError({
            message: cardIsExpired,
            path: "month"
          })
        }
      }
    }),
  year: yup.string().test({
    name: "cbYearVerification",
    message: "",
    test(value) {
      if (!value) {
        return this.createError({
          message: requiredMessage,
          path: "year"
        })
      }
      if (!value.match(yyyyDateFormatPattern)) {
        return this.createError({
          message: yearFormatMessage,
          path: "year"
        })
      }

      const cardExpirationDate = moment(
        this.options.parent?.month + "/" + value,
        "MM/YYYY",
        true
      )
      const currentDate = moment()

      if (
        cardExpirationDate.isValid() &&
        (cardExpirationDate.year() !== currentDate.year() ||
          cardExpirationDate.month() !== currentDate.month()) &&
        currentDate.isAfter(cardExpirationDate)
      ) {
        return this.createError({
          message: cardIsExpired,
          path: "year"
        })
      }
    }
  }),
  cvv: yup.string().test({
    name: "cvvTest",
    message: "",
    test(value) {
      if (!value) {
        return this.createError({
          message: requiredMessage,
          path: "cvv"
        })
      }
      if (!value.match(threeDigitsPattern)) {
        return this.createError({
          message: mustBeComposedOfThreeDigitsMessage,
          path: "cvv"
        })
      }
    }
  }),
  cardNumber: yup.string().test({
    name: "cardNumberTest",
    message: "",
    test(value) {
      if (!value) {
        return this.createError({
          message: requiredMessage,
          path: "cardNumber"
        })
      }
      let trimedValue = (" " + value).slice(1)
      trimedValue = trimedValue.replace(/\s/g, "")
      if (!trimedValue.match(twelveToNineteenDigitsPattern)) {
        return this.createError({
          message: twelveToNineteenDigitsMessage,
          path: "cardNumber"
        })
      }
    }
  })
})

export default (values) => schema.validate(values, { abortEarly: false })
